import { combineReducers } from "redux";
import * as actions from "../../actions/types";
import { GiftCard } from "../../types/gift-card";
import { createSelector } from "reselect";
import { getAppConfig } from "..";

const walletCardDetailOpen = (state = false, action) => {
    switch (action.type) {
        case actions.USER_WALLET_CARD_DETAIL_OPEN:
            return true;
        case actions.USER_WALLET_CARD_DETAIL_CLOSE:
        case actions.USER_WALLET_CARD_REMOVE_SUCCESS:
            return false;
        default:
            return state;
    }
};

const cards = (state: Array<GiftCard> | null = null, action) => {
    switch (action.type) {
        case actions.USER_WALLET_CARDS_FETCH_SUCCESS:
            return action.payload;
        case actions.USER_WALLET_CARD_REMOVE_SUCCESS:
            return state ? state.filter((card) => card.id !== action.id) : state;
        default:
            return state;
    }
};

const selectedCard = (state: GiftCard | null = null, action) => {
    switch (action.type) {
        case actions.USER_WALLET_CARD_DETAIL_OPEN:
            return action.payload;
        case actions.USER_WALLET_CARD_BALANCE_FETCH_SUCCESS:
            if (state && state.id === action.id) {
                return { ...state, balance: action.payload };
            }
        case actions.USER_WALLET_CARD_PIN_REQUEST_SUCCESS:
            if (state && state.id === action.id) {
                return { ...state, pin: action.payload.pin };
            }
        case actions.USER_WALLET_CARD_REMOVE_SUCCESS:
            return null;
        default:
            return state;
    }
};

const purchaseOptions = (state = null, action) => {
    switch (action.type) {
        case actions.WALLET_PURCHASE_OPTIONS_FETCH_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

const cardRemoving = (state = false, action) => {
    switch (action.type) {
        case actions.USER_WALLET_CARD_REMOVE:
            return true;
        case actions.USER_WALLET_CARD_REMOVE_SUCCESS:
        case actions.USER_WALLET_CARD_REMOVE_ERROR:
            return false;
        default:
            return state;
    }
}

const pinRequesting = (state = false, action) => {
    switch (action.type) {
        case actions.USER_WALLET_CARD_PIN_REQUEST:
            return true;
        case actions.USER_WALLET_CARD_PIN_REQUEST_SUCCESS:
        case actions.USER_WALLET_CARD_PIN_REQUEST_ERROR:
        case actions.AUTH_LOGIN_REQUEST_PIN_CLOSE:
            return false;
        default:
            return state;
    }
}

const addCardInfo = (state = null, action) => {
    switch (action.type) {
        case actions.USER_WALLET_ADD_CARD_VALIDATE_SUCCESS:
            return action.payload;
        case actions.USER_WALLET_ADD_CARD_CANCEL:
        case actions.USER_WALLET_ADD_CARD_VALIDATE_ERROR:
            return null;
        default:
            return state;
    }
};

const addCardProcessing = (state = false, action) => {
    switch (action.type) {
        case actions.USER_WALLET_ADD_CARD_VALIDATE:
        case actions.USER_WALLET_ADD_CARD_CONFIRM:
            return true;
        case actions.USER_WALLET_ADD_CARD_VALIDATE_SUCCESS:
        case actions.USER_WALLET_ADD_CARD_VALIDATE_ERROR:
        case actions.USER_WALLET_ADD_CARD_CONFIRM_SUCCESS:
        case actions.USER_WALLET_ADD_CARD_CONFIRM_ERROR:
        case actions.USER_WALLET_ADD_CARD_CANCEL:
            return false;
        default:
            return state;
    }
};

export const getUserWalletAddCardInfo = (state) =>
    state.user.walletCards.addCardInfo;

export const isWalletCardAdding = (state) =>
    state.user.walletCards.addCardProcessing;

export const getWalletCards = (state) =>
    state.user.walletCards.cards;

export const isWalletCardDetailOpen = (state) =>
    state.user.walletCards.walletCardDetailOpen;

export const getSelectedCard = (state) =>
    state.user.walletCards.selectedCard;

export const getWalletPurchaseOptions = (state) =>
    state.user.walletCards.purchaseOptions;

export const isWalletCardRemoving = (state) =>
    state.user.walletCards.cardRemoving;

export const isWalletCardPinRequesting = (state) =>
    state.user.walletCards.pinRequesting;

export const getEnabledCardTypes = createSelector(
    [getAppConfig],
    (appConfig) => appConfig.wallet
        ? Object.keys(appConfig.wallet.gift_card_types)
        : []
);

export const getWalletCardTypesImages = createSelector(
    [getAppConfig],
    (appConfig) => appConfig.wallet
        ? appConfig.wallet.images
        : {}
);

export default combineReducers({
    addCardInfo,
    addCardProcessing,
    cards,
    cardRemoving,
    pinRequesting,
    purchaseOptions,
    selectedCard,
    walletCardDetailOpen,
});
